<script setup>
import {ChevronDownIcon} from '@heroicons/vue/24/outline';

const props = defineProps({
    faq: Object,
    modelValue: String,
});

const emits = defineEmits(['update:modelValue']);

function toggle() {
    if (props.modelValue === props.faq.id) {
        emits('update:modelValue', '');
        return;
    }
    emits('update:modelValue', props.faq.id);
}
</script>
<template>
    <div class="lg:text-md text-sm">
        <button
            class="flex w-full gap-4 bg-gray-200 px-8 py-4 text-left font-bold uppercase md:gap-15 "
            @click="toggle"
        >
            <span class="flex flex-1">
                {{ faq.question }}
            </span>
            <ChevronDownIcon
                class="size-6 self-center"
                :class="{ 'rotate-180': faq.id === modelValue }"
            />
        </button>
        <div
            v-if="faq.id === modelValue"
            class="px-8 py-4"
        >
            {{ faq.answer }}
        </div>
    </div>
</template>
